import type { LucideIcon } from 'lucide-react';

export interface MenuItem {
    id: NavPathOverrideEnum;
    name: string;
    href?: string;
    icon: LucideIcon;
    subItems?: MenuSubItem[];
    count?: number;
}

export interface MenuSubItem {
    id: NavPathOverrideEnum;
    name: string;
    href: string;
    icon: LucideIcon;
}

export enum NavPathOverrideEnum {
    HOME = 'home',
    CUSTOMERS = 'customers',
    INVENTORY = 'inventory',
    SALES = 'sales',
    SALES_INSIGHTS = 'sales_insights',
    SALES_QUOTES = 'sales_quotes',
    SALES_ORDERS = 'sales_orders',
    EXPLORER = 'explorer',
    TASKS = 'tasks',
    SALES_DRAFTS = 'drafts',
    TRANSACTIONS = 'transactions',
    EVENTS = 'events',
}
